<template>
    <div>
        <FatorRisco
            :form="form.cidadao.questionarioSaude"
            :model="model"
        />

        <Gestante
            v-if="isGestante()"
            :form="form"
            :model="model"
        />

        <CondicaoSaude
            :form="form"
            :model="model"
        />

        <Alergia
            :data="{ form: form.cidadao.questionarioSaude, model: model.cidadao }"
            hide-info
        />

        <MedicamentoUsoContinuo
            :data="{ form: form.cidadao.questionarioSaude, model: model.cidadao }"
            hide-info
        />
    </div>
</template>

<script>
import FatorRisco from './components/fator-risco/Index'
import Alergia from '@/components/cadastro/cidadao/components/alergia/Index'
import MedicamentoUsoContinuo from '@/components/cadastro/cidadao/components/medicamento-uso-continuo/Index'
import CondicaoSaude from '@/components/cadastro/paciente/tabs/components/condicao-saude/Index'
import Gestante from '@/components/cadastro/paciente/tabs/components/gestante/Index'
import fatorRisco from '@/enums/cadastro/cidadao/fatorRisco'

export default {
    components: { FatorRisco, Alergia, MedicamentoUsoContinuo, CondicaoSaude, Gestante },
    methods: {
        isGestante() {

            const fatoresRisco = this.model.cidadao.fatoresRisco

            const gestante = fatoresRisco
                ? fatoresRisco.find(fator => fator == this.enums.fatorRisco.GESTANTE)
                : false

            return  gestante ? true : false
        }
    },
    data: () => ({
        enums: {
            fatorRisco,
        },
    }),
    props: {
        form: { type: Object, required: true },
        model: { type: Object, required: true },
    },
}
</script>